<template>
  <v-app-bar
    app
    :class="`be-app-bar pb-2 ${scrollClass}`"
    elevation="0"
  >
    <router-link :to="{ name: 'HomeView' }">
      <v-img
        class="mx-2"
        :src="logo"
        max-height="60"
        max-width="95"
        contain
        alt="Be Ética"
      ></v-img>
    </router-link>

    <v-spacer></v-spacer>
    <v-menu
      bottom
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          text
          class="white--text"
          v-bind="attrs"
          v-on="on"
          style="font-weight: normal;"
        >
          <v-icon
            class="me-1"
            size="16"
            >fa-user</v-icon
          >
          {{ getFirstName() }}
          <v-icon size="20">mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list>
        <template v-for="(menu, idx) in menus">
          <v-list-item
            :to="{ name: menu.to }"
            :key="`menu_` + idx"
          >
            <v-list-item-icon>
              <v-icon v-text="menu.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content class="ms-n3">
              <v-list-item-title>{{ $t(menu.title) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-divider></v-divider>

        <a
          v-if="hasModules(['lgpd'])"
          href="/lgpd/index.html"
          style="text-decoration: none; color: #212121"
          target="_blank"
        >
          <v-list-item
            class="link"
            style="cursor: pointer"
          >
            <v-list-item-icon>
              <v-icon>mdi-open-in-new</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="ms-n3 pa-0">
              <v-list-item-title style="text-decoration: none; color: #212121">
                LGPD
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </a>

        <a
          href="/compliance/homepage"
          style="text-decoration: none; color: #212121"
          target="_blank"
          v-if="hasModules(['compliance'])"
        >
          <v-list-item
            class="link"
            style="cursor: pointer"
          >
            <v-list-item-icon>
              <v-icon>mdi-open-in-new</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="ms-n3 pa-0">
              <v-list-item-title style="text-decoration: none; color: #212121">
                Compliance
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </a>

        <a
          v-if="hasModules(['standards'])"
          href="/standards/"
          style="text-decoration: none; color: #212121"
          target="_blank"
        >
          <v-list-item
            style="cursor: pointer"
            class="link"
          >
            <v-list-item-icon>
              <v-icon>mdi-open-in-new</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="ms-n3 pa-0">
              <v-list-item-title style="text-decoration: none; color: #212121">
                Standards
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </a>

        <a
          v-if="hasModules(['ombudsman'])"
          href="/ouvidoria/relatos?status=open&status=under_analysis"
          style="text-decoration: none; color: #212121"
          target="_blank"
        >
          <v-list-item
            style="cursor: pointer"
            class="link"
          >
            <v-list-item-icon>
              <v-icon>mdi-open-in-new</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="ms-n3 pa-0">
              <v-list-item-title style="text-decoration: none; color: #212121">
                {{ $t("menu.labels.ombudsman") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </a>

        <v-divider></v-divider>

        <v-list-item @click="logout">
          <v-list-item-icon>
            <v-icon>mdi-power</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="ms-n3">
            <v-list-item-title>Sair </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import logo from "@/assets/logo.png";
import TourButton from "@/components/StoryLaneEmbed/TourButton"

export default {
  components: {
    TourButton
  },
  data() {
    return {
      logo,
      scrollClass: "",
      menus: [
        {
          title: "menu.labels.profile",
          icon: "mdi-account",
          to: "Profile",
        },
      ]
    };
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll(event) {
      if (window.top.scrollY < 60) {
        this.scrollClass = "";
      } else {
        this.scrollClass = "on-scrool";
      }
    },
    hasModules(modules) {
      for (let i = 0; i < modules.length; i++) {
        if (this.$store.state.user.user_modules.indexOf(modules[i]) != -1) {
          return true;
        }
      }
      return false;
    },

    getFirstName() {
      const name = this.$options.filters.formatDeletedUser(this.$store.state.user.name);
      return name.split(" ")[0];
    },

    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("user_roles");
      localStorage.removeItem("role");
      sessionStorage.removeItem("goto");
      window.location = "/compliance/login";
    },
    checkModel() {
      if (this.$store.state.user.user_modules.indexOf("compliance") !== -1) {
        return true;
      }
      return false;
    },
    goToCompliance() {
      window.open(
        "https://" + this.$store.state.user.company.subdomain + "/compliance",
        "_blank",
      );
    },
  },
};
</script>

<style scoped lang="scss">
.be-app-bar {
  background-color: transparent !important;
}
.be-app-bar.on-scrool {
  background-color: rgba(34, 97, 121, 0.9) !important;
}

.link:hover {
  background-color: rgba(247, 247, 247, 255);
}

.high-contrast-settings {
  .be-app-bar.on-scrool {
    background-color: var(--v-background-high-base) !important;
  }
}
</style>
